import * as React from 'react'
import { Helmet } from 'react-helmet-async'

import * as Herz from '@rushplay/herz'

// This wrapper enables SEON
export function SeonProvider(props) {
  return (
    <Herz.Seon.FingerprintProvider
      {...props}
      disabled={!process.browser}
      renderScript={props => (
        <Helmet>
          <script {...props} />
        </Helmet>
      )}
    />
  )
}
